import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ShiftOptions } from 'models/ICattlesData'
import cattlesApiServices from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export interface IFinishedIdentifications {
	day_period: ShiftOptions
	camera_id: number
	date: number
}

export const useFinishedIdentification = () => {
	const dispatch = useAppDispatch()

	return useMutation<any, AxiosError, IFinishedIdentifications>({
		mutationFn: (props: IFinishedIdentifications) => {
			return cattlesApiServices.postCompleteIdentificationByShift(props)
		},
		retry: 1,
		onSuccess: (_data, variables) => {
			dispatch(
				notifyUser({
					title: 'Успех',
					description: 'Вы успешно оцифровали стадо',
					isError: false,
				}),
			)
		},
		onError: (_error, variables) => {
			dispatch(
				notifyUser({
					title: 'Что-то пошло не так',
					description: 'Попробуйте позже',
					isError: true,
				}),
			)
		},
	})
}
